import React from 'react';
import { PageTitle } from '../../../_metronic/layout/core';
import { RulerConfig } from './components/RulerConfig';
import { NotificationTriggers } from './components/NotificationTriggers';
import { GatewayConfig } from './components/GatewayConfig';
import { useAuth } from '../../modules/auth';
import { WhiteLabelProvider } from './components/WhiteLabelProvider';

import { PlansTab } from './components/PlansTab';
import { CheckoutConfigTab } from './components/CheckoutConfigTab';
import { CouponsTab } from './components/CouponsTab';

const SubscriptionSettingsPage: React.FC = () => {
  const [activeTab, setActiveTab] = React.useState<'planos' | 'cupons' | 'checkout' | 'automacao'>('planos');

  return (
    <>
      <div className='card mb-5 mb-xl-10'>
        <div className='card-body pt-9 pb-0'>
          <h3 className='card-title align-items-start flex-column mb-7'>
            <span className='card-label fw-bolder fs-3 mb-1'>Controles de Cobrança</span>
          </h3>
          <div className='d-flex overflow-auto h-55px'>
            <ul className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder flex-nowrap'>
              <li className='nav-item'>
                <a
                  className={`nav-link text-active-primary me-6 ${activeTab === 'planos' && 'active'}`}
                  onClick={() => setActiveTab('planos')}
                  style={{ cursor: 'pointer' }}
                >
                  Planos
                </a>
              </li>
              <li className='nav-item'>
                <a
                  className={`nav-link text-active-primary me-6 ${activeTab === 'cupons' && 'active'}`}
                  onClick={() => setActiveTab('cupons')}
                  style={{ cursor: 'pointer' }}
                >
                  Cupons
                </a>
              </li>
              <li className='nav-item'>
                <a
                  className={`nav-link text-active-primary me-6 ${activeTab === 'checkout' && 'active'}`}
                  onClick={() => setActiveTab('checkout')}
                  style={{ cursor: 'pointer' }}
                >
                  Config. Checkout
                </a>
              </li>
              <li className='nav-item'>
                <a
                  className={`nav-link text-active-primary me-6 ${activeTab === 'automacao' && 'active'}`}
                  onClick={() => setActiveTab('automacao')}
                  style={{ cursor: 'pointer' }}
                >
                  Automação e Gateway
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className='tab-content'>
        {activeTab === 'planos' && <PlansTab />}
        {activeTab === 'cupons' && <CouponsTab />}
        {activeTab === 'checkout' && <CheckoutConfigTab />}
        {activeTab === 'automacao' && (
          <>
            <RulerConfig />

            {/* ================================= */}
            {/* Será implementado posteriormente */}
            {/* <NotificationTriggers /> */}
            {/* ================================= */}

            <GatewayConfig />
          </>
        )}
      </div>
    </>
  );
};

export const SubscriptionSettingsWrapper: React.FC = () => {
  const { currentUser } = useAuth();
  const company = currentUser?.companies?.[0] || null;

  return (
    <WhiteLabelProvider company={company}>
      <PageTitle breadcrumbs={[]}>Controles de Cobrança</PageTitle>
      <SubscriptionSettingsPage />
    </WhiteLabelProvider>
  );
};
